export class UtilisateurBody {
  constructor(
    public readonly givenName: string,
    public readonly surname: string,
    public readonly displayName: string,
    public readonly mail: string,
    public readonly mobilePhone: string,
    public readonly accountEnabled: boolean,
    public readonly keolisAADAccount: boolean,
    public readonly entite_id: number,
    public readonly userPrincipalName?: string,
    public readonly id_adb2c?: string) {
  }
}
